import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    // Preserve scroll on browser back/forward so returning to a list page
    // lands where the user left off. Only reset on fresh PUSH/REPLACE nav.
    if (navigationType === 'POP') return;
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant',
    });
  }, [pathname, navigationType]);

  return null;
};

export default ScrollToTop;
